/* globals zenscroll */
import Vue from 'vue';

Vue.component('glossary-component', {
    props: ['activeletters'],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        zenscroll.setup(null, 193);

        this.activeletters.forEach(this.addActiveClass);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        addActiveClass(item, index) {
            const link = document.querySelector(`[data-letter="${item.letter}"]`);
            link.classList.add('has-items');
            link.href = `#${item.letter}`;

            if (index === 0) {
                link.classList.add('active');
            }
        },

        updateActiveClass(event) {
            const element = event.currentTarget;
            if (element.hasAttribute('href')) {
                document.querySelector('.glossary-topics__list-link.active').classList.remove('active');
                element.classList.add('active');
            }
        },
    },
});
